<template>
  <div>
    <CRow>
      <CCol col="12" lg="8">
        <CCard>
          <CCardHeader>
            <strong>Πρότυπο:</strong> {{ title }}
          </CCardHeader>
          <CCardBody>
            <CTabs>
              <CTab title="Γενικές Πληροφορίες" active>
                <CCard>
                  <CCardBody>
                    <CDataTable 
                      striped 
                      small 
                      fixed
                      :items="items" 
                      :fields="fields"
                    >
                      <template slot="value" slot-scope="data">
                        <td><strong>{{data.item.value}}</strong></td>
                      </template>
                    </CDataTable>
                  </CCardBody>
                </CCard>
              </CTab>
              <CTab title="EA / NACE">
                <CCard>
                  <CCardBody>
                    <CDataTable
                      :items="filteredItems"
                      :fields="service_subcategory_fields"
                      :items-per-page="10"
                      pagination
                      column-filter
                      table-filter
                      hover
                      :loading="loading"
                      sorter
                    >
                    <template #active-filter>
                      <div class="selectFilter">
                        <CSelect
                          :options="statusOptions"
                          :value.sync="selectedOption"
                        />
                      </div>
                    </template>
                    <template #active="{item}">
                      <td>
                        <CBadge :color="getBadge(item.active)">{{ getBadgeText(item.active) }}</CBadge>
                      </td>
                    </template>
                    <template #edit="{item}">
                      <td>
                        <CButton color="primary" @click="editSubcategory(item.id)">Επεξεργασία</CButton>
                      </td>
                    </template>
                    <template #show="{item}">
                      <td>
                        <CButton color="primary" @click="showSubcategory(item.id)">Προβολή</CButton>
                      </td>
                    </template>
                  </CDataTable>
                  </CCardBody>
                </CCard>
              </CTab>
            </CTabs>
          </CCardBody>
          <CCardFooter>
            <CButton color="primary" @click="goBack">Πίσω</CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Service',
  data: () => {
    return {
      items: [],
      service_subcategory: [],
      title: '',
      selectedOption: 'Καμία επιλογή',
      statusOptions: ['Καμία επιλογή', 'Ενεργό', 'Ανενεργό'],
      loading: true,
      fields: [
        {key: 'key', label: 'Πεδίο'},
        {key: 'value', label: 'Τιμή'},
      ],
      service_subcategory_fields: [
        {
          key: 'name', 
          label: 'ΕΑ / NACE', 
          sorter: true, 
          filter: true
        },
        {
          key: 'active', 
          label: 'Κατάσταση', 
          sorter: false, 
          filter: true
        },
        { 
          key: 'edit', 
          label: '', 
          sorter: false, 
          filter: false
        },
        { 
          key: 'show', 
          label: '', 
          sorter: false, 
          filter: false
        },
      ]
    }
  },
  computed: {
    filteredItems() {
      if (this.selectedOption == "Καμία επιλογή") {
        return this.service_subcategory;
      }
      return this.service_subcategory.filter(item => {
        const status = item.active == 1 ? 'Ενεργό' : 'Ανενεργό'
        return status == this.selectedOption
      })
    }
  },
  methods: {
    getServiceData (id) {
      const service = servicesData.find((service, index) => index + 1 == id)
      const serviceDetails = service ? Object.entries(service) : [['id', 'Not found']]
      return serviceDetails.map(([key, value]) => { return { key, value } })
    },
    getBadge (status) {
      return status === 1 ? 'success' : 'secondary'
    },
    getBadgeText (status) {
      return status === 1 ? 'Ενεργό' : 'Ανενεργό'
    },
    goBack() {
      this.$router.go(-1)
    },
    subcategoryLink(id) {
      return `./subcategory/${id.toString()}`
    },
    showSubcategory(id) {
      const subcategoryLink = this.subcategoryLink(id);
      this.$router.push({path: subcategoryLink});
    },
    editSubcategoryLink(id) {
      return `./subcategory/${id.toString()}/edit`
    },
    editSubcategory(id) {
      const subcategoryLink = this.editSubcategoryLink(id);
      this.$router.push({path: subcategoryLink});
    }
  },
  mounted: function(){
    let self = this;
    axios.get('/api/services/' + self.$route.params.id + '?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
      const ser_items = Object.entries(response.data).map(([key, value]) => {return {key: key, value: value}});
      const keys = ["id", "name", "iaf_title", "scheme_name", "iaf_prefix", "group_name", "description", "case_code_prefix"];
      self.items = ser_items.filter((t) => keys.includes(t.key));
      self.title = self.items.find((t) => t.key == "name").value;

      self.items = self.items.map((item) => {
         if (item.key == "id") {
            item.key = "ID:";
        } else if (item.key == "name") {
            item.key = "Τίτλος:";
        } else if (item.key == "iaf_title") {
            item.key = "Standard name (IAF):";
        } else if (item.key == "scheme_name") {
            item.key = "Scheme Name:";
        } else if (item.key == "iaf_prefix") {
            item.key = "Πρόθεμα IAF:";
        } else if (item.key == "group_name") {
            item.key = "Ομάδα:";
        } else if (item.key == "description") {
            item.key = "Περιγραφή:";
        } else if (item.key == "case_code_prefix") {
            item.key = "Πρόθεμα κωδικού υπόθεσης:";
        }

        return item;
      });

      self.loading = false;
      self.service_subcategory = ser_items.find((t) => t.key == "service_subcategories");
      self.service_subcategory = self.service_subcategory.value;
    }).catch(function (error) {
      console.log(error);
      self.loading = false;
      self.$router.push({ path: '/login' });
    });
  }
}

</script>
